import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Location } from '@next/core-lib/business-partner-aggregation-api';
import { AgrPrintPageModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { CowWithMeasurement } from '../../../models/cow.model';

@Component({
  selector: 'cow-table-print',
  templateUrl: './cow-table-print.component.html',
  styleUrls: ['./cow-table-print.component.scss'],
  standalone: true,
  imports: [CommonModule, AgrPrintPageModule, AgrI18nSharedModule],
})
export class CowTablePrintComponent {
  printTableData = input<CowWithMeasurement[]>([]);
  measurementDate = input<Date>();
  location = input<Location>();
}
